import React, { useState } from "react";

import { createPortal } from "react-dom";

const CommonContactModal = ({ open, onClose, profileData }) => {

    const [copied, setCopied] = useState(false);


    
  if (!open || !profileData) return null;

  const isError = profileData.type === "error";
  const isSuccess = profileData.type === "success";



const cta = (() => {
  const code = profileData?.errorCode;

  // if (code === "PROFILE_005") {
  //   return { label: "OK", onClick: onClose };
  // }

  if (code === "PROFILE_005") {
  return {
    label: "8600555740",
    onClick: async () => {
      await navigator.clipboard.writeText("8600555740");
      setCopied(true);

      setTimeout(() => {
        onClose();
      }, 800);
    },
  };
}

  if (code === "KYC_001") {
    return { label: "Complete KYC", onClick: () => (window.location.href = "/kyc") };
  }

  if (code && code.startsWith("MEMBERSHIP_")) {
    
     return { label: "Upgrade Plan", onClick: () => (window.location.href = "/upgrade") };
  }

  // default includes MEMBERSHIP_001
  return { label: "OK",  onClick: onClose };
})();


const handlePrimaryClick = () => {
  // for success (phone shown) → just close
  if (isSuccess) return onClose();

  // for error → use cta rules
  return cta.onClick();
};


  const resolveProfilePhoto = (photo, fallbackPhoto) => {
    if (!photo || photo === "null" || photo.trim() === "") {
      return fallbackPhoto;
    }
    return photo;
  };

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Montserrat",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 580,
          height: 420,
          borderRadius: 30,
          background: "#fff",
          position: "relative",
          textAlign: "center",
          overflow: "hidden",
        }}
      >
        {/* top curve bg */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: 150,
            background: "linear-gradient(180deg, #FFF5F0 0%, #FFFFFF 100%)",
          }}
        />

        {/* close */}
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            width: 45,
            height: 45,
            borderRadius: "50%",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: 22,
            zIndex: 2,
          }}
        >
          ✕
        </div>

      {/* profile photo with blur background */}
<div
  style={{
    width: 100,
    height: 100,
    borderRadius: "50%",
    position: "absolute",
    top: 54,
    left: "50%",
    transform: "translateX(-50%)",
    overflow: "hidden",
    boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
    background: "#fff",
  }}
>
  {/* BLURRED BACKGROUND */}
  <div
    style={{
      position: "absolute",
      inset: 0,
      backgroundImage: `url("${resolveProfilePhoto(
        profileData.photo,
        profileData.fallbackPhoto
      )}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      filter: "blur(12px)",
      transform: "scale(1.2)",
    }}
  />

  {/* FOREGROUND IMAGE (CONTAIN SAFE) */}
  <img
    src={resolveProfilePhoto(
      profileData.photo,
      profileData.fallbackPhoto
    )}
    alt="profile"
    style={{
      position: "absolute",
      inset: 0,
      margin: "auto",
      width: "100%",
      height: "100%",
      objectFit: "contain",
      borderRadius: "50%",
    }}
  />
</div>

        {/* profile id */}
        <div
          style={{
            position: "absolute",
            top: 170,
            left: "50%",
            transform: "translateX(-50%)",
            padding: "8px 16px",
            borderRadius: 11,
            border: "1px solid rgba(255,111,97,0.5)",
            background: "rgba(255,240,240,0.5)",
            fontSize: 14,
          }}
        >
          <b>Profile ID :</b>{" "}
          <span style={{ fontWeight: 500 }}>
            {profileData.user_info?.register_id}
          </span>
        </div>

        {/* title */}
        <div
          style={{
            position: "absolute",
            top: 237,
            width: "100%",
            fontSize: 25,
            fontWeight: 700,
          }}
        >
          {isSuccess ? "Contact Details" : "Contact Details Locked"}
        </div>

        {/* message */}
        <div
          style={{
            position: "absolute",
            top: 285,
            left: "50%",
            transform: "translateX(-50%)",
            width: 508,
            fontSize: 15,
            lineHeight: "26px",
            color: "#7c7c7c",
          }}
        >
          {isSuccess && (
            <div style={{ fontSize: 22, fontWeight: 600 }}>
               {profileData.phone}
            </div>
          )}

          {/* {isError && profileData.message} */}

          {isError && (
  <>
    {profileData.errorCode === "PROFILE_005" && copied ? (
      <div style={{ fontSize: 18, fontWeight: 600 }}>
        Number copied to clipboard
      </div>
    ) : (
      profileData.message
    )}
  </>
)}
        </div>

        {/* upgrade button (ONLY for error) */}
        {/* {isError && (
          <div
            onClick={() => (window.location.href = "/upgrade")}
            style={{
              position: "absolute",
              bottom: 32,
              left: "50%",
              transform: "translateX(-50%)",
              width: 390,
              height: 45,
              borderRadius: 50,
              background:
                "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Upgrade Plan
          </div>
        )} */}


{/* CTA button (ONLY for error) */}
{/* {isError && (
  <div
    // onClick={() => (window.location.href = cta.href)}
    onClick={cta.onClick}
    style={{
      position: "absolute",
      bottom: 32,
      left: "50%",
      transform: "translateX(-50%)",
      width: 390,
      height: 45,
      borderRadius: 50,
      background:
        "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      cursor: "pointer",
    }}
  >
    {cta.label}
  </div>
)} */}


{/* CTA button for error and ok for sucess */}
{(isError || isSuccess) && (
  <div
    onClick={handlePrimaryClick}
    style={{
      position: "absolute",
      bottom: 32,
      left: "50%",
      transform: "translateX(-50%)",
      width: "max-content",
      minWidth: 200,
      height: 45,
      borderRadius: 50,
      background:
        "linear-gradient(180deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      cursor: "pointer",
    }}
  >
    {/* success should always show OK */}
    {isSuccess ? "OK" : cta.label}
  </div>
)}


        
      </div>
    </div>,
    document.body
  );
};

export default CommonContactModal;
